export default __webpack_public_path__ + "static/media/dashboard.b281a9bd.svg";